/**
 * @generated SignedSource<<8b3381b1523af912386bc90ae0003173>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SettingsDepartureLocationEditPageQuery$variables = {
  id: string;
};
export type SettingsDepartureLocationEditPageQuery$data = {
  readonly departureLocation: {
    readonly name: string;
    readonly " $fragmentSpreads": FragmentRefs<"DepartureLocationEditForm_departureLocation" | "EntitySidebar_entity">;
  } | null;
};
export type SettingsDepartureLocationEditPageQuery = {
  response: SettingsDepartureLocationEditPageQuery$data;
  variables: SettingsDepartureLocationEditPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SettingsDepartureLocationEditPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DepartureLocation",
        "kind": "LinkedField",
        "name": "departureLocation",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "DepartureLocationEditForm_departureLocation"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "EntitySidebar_entity"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SettingsDepartureLocationEditPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DepartureLocation",
        "kind": "LinkedField",
        "name": "departureLocation",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "codes",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "uuid",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedAt",
                "storageKey": null
              }
            ],
            "type": "Entity",
            "abstractKey": "__isEntity"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e3940c67e9fe8e10230a942915535107",
    "id": null,
    "metadata": {},
    "name": "SettingsDepartureLocationEditPageQuery",
    "operationKind": "query",
    "text": "query SettingsDepartureLocationEditPageQuery(\n  $id: ID!\n) {\n  departureLocation(id: $id) {\n    name\n    ...DepartureLocationEditForm_departureLocation\n    ...EntitySidebar_entity\n    id\n  }\n}\n\nfragment DepartureLocationEditForm_departureLocation on DepartureLocation {\n  id\n  name\n  codes\n}\n\nfragment EntitySidebar_entity on Entity {\n  __isEntity: __typename\n  uuid\n  createdAt\n  updatedAt\n}\n"
  }
};
})();

(node as any).hash = "2c3fd9f15c62bf14d5c76d9df6ff1bd2";

export default node;
